module.exports = __webpack_public_path__ + "static/media/regal-rush-blue-bg-gold-200x89.20726b08.png";